module.exports = __webpack_public_path__ + "static/media/wiz trans.d602bc80.webp";